import api from "@/axios";

export default {
  findAll() {
    return api().get("contact-us-topic");
  },
  findOne(id) {
    return api().get(`admin/contact-us-topic/${id}`);
  },
  create(data) {
    return api().post("admin/contact-us-topic/add", data);
  },
  update(id, data) {
    return api().patch(`admin/contact-us-topic/${id}`, data);
  },
  remove(id) {
    return api().delete(`contact-us-topic/${id}`);
  },
};
